import React, { useState, useEffect } from "react";
import logo from "../../resource/7.png";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const GuestSpeakerRequest = () => {
  const [formData, setFormData] = useState({
    "organiser_full_name": "",
    "organiser_gender": "",
    "organiser_mobile_number": "",
    "organiser_whatsapp_number": "",
    "organiser_email_address": "",
    "guest_full_name": "idk",
    "guest_first_name": "",
    "guest_last_name": "",
    "guest_date_of_birth": "",
    "guest_gender": "",
    "guest_email_address": "",
    "aranya_temple_name": "",
    "country_of_residence": ""
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    // Validate Organiser Full Name
    if (!formData.organiser_full_name)
      newErrors.organiser_full_name = "Organiser's full name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.organiser_full_name))
      newErrors.organiser_full_name =
        "Organiser's full name should contain only letters, spaces, or hyphens";

    // Validate Organiser Gender
    if (!formData.organiser_gender)
      newErrors.organiser_gender = "Organiser's gender is required";

    // Validate Organiser Mobile Number
    if (!formData.organiser_mobile_number)
      newErrors.organiser_mobile_number = "Organiser's mobile number is required";
    else if (!/^\d{10}$/.test(formData.organiser_mobile_number))
      newErrors.organiser_mobile_number =
        "Organiser's mobile number should be 10 digits";

    // Validate Organiser WhatsApp Number
    if (!formData.organiser_whatsapp_number)
      newErrors.organiser_whatsapp_number =
        "Organiser's WhatsApp number is required";
    else if (!/^\d{10}$/.test(formData.organiser_whatsapp_number))
      newErrors.organiser_whatsapp_number =
        "Organiser's WhatsApp number should be 10 digits";

    // Validate Organiser Email
    if (!formData.organiser_email_address)
      newErrors.organiser_email_address = "Organiser's email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.organiser_email_address))
      newErrors.organiser_email_address = "Invalid email format";

    // Validate Guest Full Name
    if (!formData.guest_full_name)
      newErrors.guest_full_name = "Guest's full name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.guest_full_name))
      newErrors.guest_full_name =
        "Guest's full name should contain only letters, spaces, or hyphens";

    // Validate Guest First Name
    if (!formData.guest_first_name)
      newErrors.guest_first_name = "Guest's first name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.guest_first_name))
      newErrors.guest_first_name =
        "Guest's first name should contain only letters, spaces, or hyphens";

    // Validate Guest Last Name
    if (!formData.guest_last_name)
      newErrors.guest_last_name = "Guest's last name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.guest_last_name))
      newErrors.guest_last_name =
        "Guest's last name should contain only letters, spaces, or hyphens";

    // Validate Guest Date of Birth
    if (!formData.guest_date_of_birth)
      newErrors.guest_date_of_birth = "Guest's date of birth is required";

    // Validate Guest Gender
    if (!formData.guest_gender)
      newErrors.guest_gender = "Guest's gender is required";

    // Validate Guest Email
    if (!formData.guest_email_address)
      newErrors.guest_email_address = "Guest's email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.guest_email_address))
      newErrors.guest_email_address = "Invalid guest email format";

    // Validate Aranya Temple Name
    if (!formData.aranya_temple_name)
      newErrors.aranya_temple_name = "Aranya temple name is required";

    // Validate Country of Residence
    if (!formData.country_of_residence)
      newErrors.country_of_residence = "Country of residence is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const validateAll = () => {
    const isFormValid = validateForm();

    if (!isFormValid) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the highlighted fields and try again.",
      });
      return false;
    }



    return true;
  };




const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateAll()) {
      return; // Stop execution if validation fails
    }

    setLoading(true);

    try {
      const response = await apiClient.post('/guest-speaker-requests',
        formData
      );

      console.log("Form submitted successfully:", response.data);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset the form
      setFormData({
        "organiser_full_name": "",
        "organiser_gender": "",
        "organiser_mobile_number": "",
        "organiser_whatsapp_number": "",
        "organiser_email_address": "",
        "guest_full_name": "idk",
        "guest_first_name": "",
        "guest_last_name": "",
        "guest_date_of_birth": "",
        "guest_gender": "",
        "guest_email_address": "",
        "aranya_temple_name": "",
        "country_of_residence": ""
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="form-page dark-gold ">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">
              Guest Speaker Retreat Request Form for Organisers{" "}
            </h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Welcome to Bhaddheka Vihari Monastery Guest Speaker Retreats.
        </p>
        <p className="font-p mt-5">
          Please use the following form to fill in the guest speaker and
          organiser details
        </p>

        <h1 className="font-second mt-5">Organiser Details </h1>

        <p className="font-p mt-5">Full Name of the Organiser*</p>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="organiser_full_name"
              name="organiser_full_name"
              value={formData.organiser_full_name}
              onChange={handleInputChange}
            />
            {errors.organiser_full_name && <span className="error">{errors.organiser_full_name}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              name="organiser_gender"
              value="Male"
              checked={formData.organiser_gender === "Male"}
              onChange={handleInputChange}
            />
            <label>Male</label>
          </div>
          <div>
            <input
              type="radio"
              name="organiser_gender"
              value="Female"
              checked={formData.organiser_gender === "Female"}
              onChange={handleInputChange}
            />
            <label>Female</label>
          </div>
          {errors.organiser_gender && <span className="error">{errors.organiser_gender}</span>}
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="organiser_mobile_number"
              name="organiser_mobile_number"
              value={formData.organiser_mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="mobilenumber">Mobile Number</label>
          {errors.organiser_mobile_number && <span className="error">{errors.organiser_mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="organiser_whatsapp_number"
              name="organiser_whatsapp_number"
              value={formData.organiser_whatsapp_number}
              onChange={handleInputChange}
            />
            <label htmlFor="wtnumber">WhatsApp Number</label>

           {errors.organiser_whatsapp_number && <span className="error">{errors.organiser_whatsapp_number}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="organiser_email_address"
              name="organiser_email_address"
              value={formData.organiser_email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="email">Email Address</label>
            {errors.organiser_email_address && <span className="error">{errors.organiser_email_address}</span>}
          </div>
        </div>

        <h1 className="font-second mt-5">Guest Speaker Details </h1>
        <p className="font-p mt-5">Full Name of the Guest Speaker**</p>

        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="guest_first_name"
              name="guest_first_name"
              value={formData.guest_first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="firstname">First Name</label>
            {errors.guest_first_name && <span className="error">{errors.guest_first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="guest_last_name"
              name="guest_last_name"
              value={formData.guest_last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="lastname">Last Name</label>
            {errors.guest_last_name && <span className="error">{errors.guest_last_name}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              name="guest_date_of_birth"
              value={formData.guest_date_of_birth}
              onChange={handleInputChange}
            />
            <label>Date of Birth*</label>
            {errors.guest_date_of_birth && <span className="error">{errors.guest_date_of_birth}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              name="guest_gender"
              value="Male"
              checked={formData.guest_gender === "Male"}
              onChange={handleInputChange}
            />
            <label>Male</label>
          </div>
          <div>
            <input
              type="radio"
              name="guest_gender"
              value="Female"
              checked={formData.guest_gender === "Female"}
              onChange={handleInputChange}
            />
            <label>Female</label>
          </div>
          {errors.guest_gender && <span className="error">{errors.guest_gender}</span>}
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="guest_email_address"
              name="guest_email_address"
              value={formData.guest_email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="guest_email_address">Email Address</label>
      {errors.guest_email_address && <span className="error">{errors.guest_email_address}</span>}
          </div>
        </div>

        <div className="form-item">
          <p className="font-p mt-5">
            Name of the Aranya or Temple of Residence*{" "}
          </p>
          <input
            type="text"
            id="aranya_temple_name"
            name="aranya_temple_name"
            value={formData.aranya_temple_name}
            onChange={handleInputChange}
          />
          <br />
    {errors.aranya_temple_name && <span className="error">{errors.aranya_temple_name}</span>}
        </div>

        <div className="form-item">
          <p className="font-p mt-5">Country of Residence*</p>
          <input
            type="text"
            id="country_of_residence"
            name="country_of_residence"
            value={formData.country_of_residence}
            onChange={handleInputChange}
          />
          <br />
        {errors.country_of_residence && <span className="error">{errors.country_of_residence}</span>}
        </div>

        <button type="submit" id="submitbtn" className="mt-5">
          Submit
        </button>

        <p className="font-p mt-5 pb-4">
          We look forward to facilitating your request and is grateful for
          choosing Bhaddheka Vihari Monastery an enriching space of practising
          mindfulness meditation.
        </p>
      </form>
    </div>
  );
};

export default GuestSpeakerRequest;
